import React from "react";
import { useLocation, useNavigate, useRoutes } from "react-router-dom";
import { getSubscribedRoutes, unsubscribedRoutes } from "./protected";
import { publicRoutes } from "./public";
import { commonRoutes } from "./common";
import { Alert, Box, Button } from "@mui/material";
import { useAuthenticationStore } from "../stores/auth";
import { useApiClient } from "../api";
import { ExportJobsProvider } from "../hooks/useExportJobs";

import { isHelpPath } from "../features/help/actions";

export const AppRoutes = ({ user }) => {
  const { stopImpersonation } = useAuthenticationStore();
  const navigate = useNavigate();
  const isLoggedIn = user?.isLoggedIn || false;
  const isSubscribed = user?.info?.subscribed || false;
  const isModerator =
    Boolean(user?.info?.moderator) ||
    user?.info?.roles?.some(
      (r) => String(r).toLowerCase() === "fruitify moderator",
    );
  const helpPage = isHelpPath(useLocation().pathname);
  const subscribedRoutes = helpPage
    ? []
    : getSubscribedRoutes(user?.info?.activeContext);
  const ApiClient = useApiClient();
  const routes = isLoggedIn
    ? isSubscribed || isModerator
      ? subscribedRoutes
      : unsubscribedRoutes
    : publicRoutes;
  const element = useRoutes([...routes, ...commonRoutes]);

  const handleStopImpersonation = async () => {
    await ApiClient.users.revokeToken(user.refreshToken);
    stopImpersonation(navigate);
    await ApiClient.client.clearStore();
  };
  const content = (
    <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
      {!helpPage && user?.info?.isLoggedIn && !user?.info?.isEmailVerified && (
        <Alert severity={"warning"} onClick={() => navigate(`/account/home`)}>
          Email is not verified
        </Alert>
      )}
      {user?.beingImpersonated && (
        <Alert
          severity={"warning"}
          action={
            <Button
              color="inherit"
              size="small"
              onClick={handleStopImpersonation}
            >
              Stop Impersonating
            </Button>
          }
        >
          You are currently impersonating {user.info?.firstName}{" "}
          {user.info?.lastName} ({user.info?.email})
        </Alert>
      )}
      <Box sx={{ flexGrow: 1 }}>{element}</Box>
    </Box>
  );
  return !helpPage && isLoggedIn && isSubscribed ? (
    <ExportJobsProvider>{content}</ExportJobsProvider>
  ) : (
    content
  );
};
